import "core-js/stable";
import "./styles/base.scss";
import { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { StagingBanner } from "./components/AdminApp/AccountsApp/StagingBanner";
import { AppScaffold } from "./components/AppScaffold";
import { MainRoutes } from "./components/MainRoutes";
import { initDatadogRum } from "./utils/datadogRum";
import { setupEntrypoint } from "./utils/entrypoint";
import { createI18nInstance } from "./utils/i18n/i18n";
const { history } = setupEntrypoint();

if (window.env.NODE_ENV === "production" || window.env.NODE_ENV === "staging") {
  void initDatadogRum();
}
void createI18nInstance();

createRoot(document.getElementById("app")!).render(
  <Suspense fallback={<div>Loading...</div>}>
    <AppScaffold history={history}>
      <StagingBanner />
      <MainRoutes />
    </AppScaffold>
  </Suspense>,
);
